export const STORAGE_INN_NAMESPACE = "inn";
export const STORAGE_TRUST_NAMESPACE = "counterparty-employee-trust";
export const STORAGE_APPOINTMENT_HEAD_ORDER = "appointment-head-order";
export const STORAGE_SIGNED_REQUEST = "master-application/request";
export const STORAGE_SERVICE_DOCUMENT_NAMESPACE = "service-document";
export const STORAGE_AGREEMENT_DOCUMENT_NAMESPACE = "agreement-document";
